import styled from 'styled-components';

import { Link } from '@qality/common-components/src/atoms/Link';

export const Gadget = styled.div<{ minHeight?: number }>`
  border: 0.5px solid var(--ds-border, var(--ds-fb-border));
  box-sizing: border-box;
  box-shadow: 5px 5px 5px
    var(--ds-shadow-overflow-spread, var(--ds-fb-shadow-overflow-spread));
  border-radius: 3px;
  margin-top: 16px;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : '259px')};
  padding: 16px;
  overflow-y: auto;
`;

export const GadgetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  min-height: 32px;
`;

export const GadgetLink = styled(Link)`
  color: var(--ds-text-accent-purple, var(--ds-fb-text-accent-purple));
  font-weight: 500;
  padding-left: 1em;
  height: 2.3em;
  line-height: 2.3em;
`;

export const GadgetExplanationText = styled.div`
  max-width: 500px;
  padding-bottom: 2em;
  color: var(--ds-text, var(--ds-fb-text));
`;

export const GedgetConfigStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  flex-direction: column;
  text-align: center;
  min-height: 259px;
`;
